module.exports = __webpack_public_path__ + "img/sqjt.a226911f.png";